import React, { FC } from 'react';
import useSetupKeepState from '../../global/hooks/useSetupKeepState';
import BrandProfileMainContent from './components/BrandProfileMainContent/BrandProfileMainContent';

const BrandProfile: FC = () => {
  const key = useSetupKeepState();
  if (key === 'replaceState') {
    return null;
  }
  return <BrandProfileMainContent key={key} />;
};

export default BrandProfile;
